module.exports = __webpack_public_path__ + "static/media/saint-helena.a6461b48.svg";